import {RouteLineMobile} from "./route-line-mobile";

export const TabContentMobile = {
    props: {
        is_active: {
            type: Boolean,
            required: true,
        },
        current_day: {
            type: String,
            required: true,
        },
        trip: {
            type: Object,
            required: true,
        },
    },
    components: {
        RouteLineMobile,
    },
    data(): object {
        return {}
    },
    computed: {},
    methods: {},
    template: `<template v-if="is_active">
                <div class="search-result-moblie__wrapper">
                    <div class="search-result-moblie__list">
                        <RouteLineMobile
                            v-for="(trip_line, trip_line_key) in trip" :key="trip_line_key"
                            :route="trip_line"
                            :current_day="current_day"
                        />
                    </div>
                </div>
        </template>`,
}